<template>
    <div id="app">
        <router-view name="header"/>
        <div>
          <div style="position: fixed;top: 20px;right: 20px;z-index: 10001; font-size: 0.7142em;">
            <n-switch v-model="switches.defaultOn" on-text="EN" off-text="FR" :input="changeLocale()"></n-switch>
          </div>
            <router-view/>
        </div>
<!--        <router-view name="footer"/>-->
    </div>
</template>
<script>
import {Switch} from "@/components";
import i18n from "@/plugins/i18n"

export default {
    components: {
      [Switch.name]: Switch,
    },
    data(){
      return{
        switches: {
          defaultOn: true,
          defaultOff: false
        },
      }
    },
    methods: {
      changeLocale() {
        if (this.switches.defaultOn)
        {
          i18n.locale = 'en'
        }
        else {
          i18n.locale = 'fr'
        }
      }
    }
  }
</script>

